import { render, staticRenderFns } from "./ProctoringGate.vue?vue&type=template&id=72ca3ef2&scoped=true&"
import script from "./ProctoringGate.vue?vue&type=script&lang=js&"
export * from "./ProctoringGate.vue?vue&type=script&lang=js&"
import style0 from "./ProctoringGate.vue?vue&type=style&index=0&id=72ca3ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca3ef2",
  null
  
)

export default component.exports